module.exports = __webpack_public_path__ + "img/signature@2x.aa79c5c.jpg";